/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Parental_Controls_Page_DescriptionInputs */

const de_parental_controls_page_description = /** @type {(inputs: Parental_Controls_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die PIN schützt vor unberechtigtem Zugriff auf FSK-18-Inhalte. Beim Abspielen von FSK-18-Inhalten werden Sie zur Eingabe aufgefordert. Wenn Sie das nicht wünschen, können Sie am Ende der Seite die Abfrage deaktivieren.`)
};

/** @type {(inputs: Parental_Controls_Page_DescriptionInputs) => LocalizedString} */
const en_parental_controls_page_description = de_parental_controls_page_description;

/**

* @param {Parental_Controls_Page_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const parental_controls_page_description = /** @type {((inputs?: Parental_Controls_Page_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Parental_Controls_Page_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_parental_controls_page_description(inputs)
	return en_parental_controls_page_description(inputs)
});